// extracted by mini-css-extract-plugin
export default {"update-button":"smallStepperButton_update-button__7TYww","icon":"smallStepperButton_icon__oAh7c"};